/* eslint-disable import/no-named-as-default */
import React, { FunctionComponent } from "react";
import { Provider } from "react-redux";
import PropTypes from "prop-types";
import store from "../../store";
import AgencyPipelineMetrics from "./AgencyPipelineMetrics";

interface IProviderComponentProps {
  recruiterId: number;
}

const ProviderComponent: FunctionComponent<IProviderComponentProps> = ({
  recruiterId,
}) => (
  <Provider store={store}>
    <AgencyPipelineMetrics recruiterId={recruiterId} />
  </Provider>
);

ProviderComponent.propTypes = {
  recruiterId: PropTypes.number.isRequired,
};

export default ProviderComponent;
